export const GET_TENDER_GROUPS = 'get_tender_groups';
export const GET_TENDER_GROUP = 'get_tender_group';
export const SAVE_TENDER_GROUP = 'save_tender_group';
export const UPDATE_TENDER_GROUP = 'update_tender_group';
export const DELETE_TENDER_GROUP = 'delete_tender_group';
export const ERROR_DATA = 'error_data';
export const CLEAN_TENDER_GROUP = 'clean_tender_group';
export const SYNCING = 'syncing';
export const LOAD_TENDER_GROUP = 'tender_group_loaded';
export const LOAD_TENDER_GROUPS = 'tender_groups_loaded';
export const CONTROL_MESSAGE_POPUP = 'control_message_popup';
